(() => {
  const ROOT_STYLE_VAR = '--sampler-box-cans-image-height';
  const ADDED_HEIGHT_VAR = '--added-height';
  const CONTENT_HEIGHT_VAR = '--content-column-height';
  const TARGET_SELECTOR = '.content-column--cans-image';
  const CONTENT_WRAPPER_SELECTOR = '.sampler-box--content-wrapper';
  const IMAGE_COLUMN_SELECTOR = '.sampler-box--image-column';
  const IMAGE_COLUMN_MARGIN_TOP_VAR = 'margin-top';
  const SECTION_SELECTOR = '.s2g-homepage-sampler';

  let resizeObserver;
  let targetEl;
  let contentWrapperEl;
  let imageColumnEl;
  let sectionEl;

  const setHeightVar = (height) => {
    const value = Number.isFinite(height) ? `${Math.round(height)}px` : '0px';
    document.documentElement.style.setProperty(ROOT_STYLE_VAR, value);
  };

  const setAddedHeightVar = (height) => {
    const value = Number.isFinite(height) ? `${Math.round(height)}px` : '0px';
    imageColumnEl?.style.setProperty(ADDED_HEIGHT_VAR, value);
  };

  const resolveToPixels = (cssValue) => {
    if (!cssValue) return 0;
    const normalized = String(cssValue).trim();
    if (!normalized) return 0;

    const pxMatch = normalized.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return parseFloat(pxMatch[1]);

    const probe = document.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = normalized;
    document.body.appendChild(probe);
    const pixels = probe.getBoundingClientRect().height;
    probe.remove();
    return pixels;
  };

  const measureAndSet = () => {
    if (!targetEl) {
      targetEl = document.querySelector(TARGET_SELECTOR);
    }

    if (!contentWrapperEl) {
      contentWrapperEl = document.querySelector(CONTENT_WRAPPER_SELECTOR);
    }

    if (!imageColumnEl) {
      imageColumnEl = document.querySelector(IMAGE_COLUMN_SELECTOR);
    }

    if (!sectionEl) {
      sectionEl =
        contentWrapperEl?.closest(SECTION_SELECTOR) ||
        imageColumnEl?.closest(SECTION_SELECTOR) ||
        document.querySelector(SECTION_SELECTOR);
    }

    if (!targetEl) {
      setHeightVar(0);
    } else {
      setHeightVar(targetEl.getBoundingClientRect().height);
    }

    if (sectionEl) {
      const contentHeight = contentWrapperEl?.getBoundingClientRect().height;
      const value = Number.isFinite(contentHeight) ? `${Math.round(contentHeight)}px` : '0px';
      sectionEl.style.setProperty(CONTENT_HEIGHT_VAR, value);
    }

    if (!imageColumnEl) {
      setAddedHeightVar(0);
      return;
    }

    const offsetValue = getComputedStyle(imageColumnEl).getPropertyValue(IMAGE_COLUMN_MARGIN_TOP_VAR);
    setAddedHeightVar(Math.abs(resolveToPixels(offsetValue)));
  };

  const init = () => {
    measureAndSet();

    if (!targetEl) return;

    if (resizeObserver) resizeObserver.disconnect();

    resizeObserver = new ResizeObserver(() => {
      measureAndSet();
    });

    resizeObserver.observe(targetEl);

    if (contentWrapperEl) {
      resizeObserver.observe(contentWrapperEl);
    }

    window.addEventListener('resize', measureAndSet, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
